import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useStressLevelPoints } from 'hooks/useStressLevelPoints'
import { StyledEnergyLevel as S } from './EnergyLevel.styles'
import { ENERGY_LEVEL_TEXT_MAP, INDICATOR_VALUES_MAP } from './constants'

export const EnergyLevel: React.FC = () => {
  const { t } = useTranslation()
  const stressValue = useStressLevelPoints()

  const { textKey, textColor } = useMemo(() => {
    return ENERGY_LEVEL_TEXT_MAP[stressValue]
  }, [stressValue])

  const indicatorValues = useMemo(
    () => INDICATOR_VALUES_MAP[stressValue],
    [stressValue],
  )

  return (
    <S.Wrapper>
      <S.Title>{t`result.energyLevel.title`}</S.Title>
      <S.Subtitle color={textColor}>{t(textKey as any)}</S.Subtitle>
      <S.BatteryContainer>
        <S.IndicatorContainer>
          {indicatorValues.map(({ id, opacity }) => (
            <S.Indicator key={id} opacityValue={opacity} />
          ))}
        </S.IndicatorContainer>
      </S.BatteryContainer>
    </S.Wrapper>
  )
}
